module.exports = __webpack_public_path__ + "img/이안에배신자가있다.0792f690.png";